//SLVI-1334-INICIO
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import axios from 'axios';

const UNPROTECTED_PATHS = ['/validar-login', '/error'];

const getCookie = (name) => {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
};

export default function useSessionGuard() {
    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        if (UNPROTECTED_PATHS.includes(location.pathname)) return;

        console.log('%c[SESSION GUARD P7] Verificando sessão na rota:', 'color: purple; font-weight: bold', location.pathname);

        //SLVI-1334-FIX-05-INICIO
        // Quando REACT_APP_USE_COLWS_AUTH=false, não existe sessionToken cookie.
        // A validação deve ser feita apenas via loginValido e expires no localStorage.
        const useColwsAuth = process.env.REACT_APP_USE_COLWS_AUTH;
        console.log('[SESSION GUARD P7] REACT_APP_USE_COLWS_AUTH:', useColwsAuth);

        if (useColwsAuth === 'false') {
            const loginValido = localStorage.getItem('loginValido');
            const expires = localStorage.getItem('expires');
            console.log('[SESSION GUARD P7] Modo sem COLWS — loginValido:', loginValido, '| expires:', expires);

            if (loginValido === null) {
                console.log('%c[SESSION GUARD P7] loginValido=null — auth inicial em andamento, aguardando', 'color: orange; font-weight: bold');
                return;
            }

            if (loginValido === 'true' && expires) {
                const expiresDate = new Date(expires);
                const now = new Date();
                console.log('[SESSION GUARD P7] expires:', expiresDate.toISOString(), '| agora:', now.toISOString(), '| válido:', expiresDate > now);
                if (expiresDate > now) {
                    console.log('%c[SESSION GUARD P7] Sessão VÁLIDA ✅ — sem cookie necessário (COLWS desabilitado)', 'color: green; font-weight: bold');
                    return;
                } else {
                    console.log('%c[SESSION GUARD P7] Sessão EXPIRADA (expires vencido) — redirecionando para re-autenticação', 'color: orange; font-weight: bold');
                    localStorage.removeItem('loginValido');
                    localStorage.removeItem('expires');
                    history.replace('/');
                    return;
                }
            }

            if (loginValido === 'false') {
                console.log('%c[SESSION GUARD P7] REDIRECIONANDO para /error — loginValido=false (COLWS desabilitado)', 'color: red; font-weight: bold');
                history.push('/error?erro=Sessão não encontrada. Acesse o portal do corretor novamente.');
                return;
            }

            // loginValido=true sem expires — aguarda Validation definir
            console.log('%c[SESSION GUARD P7] loginValido=true mas sem expires — aguardando Validation', 'color: orange; font-weight: bold');
            return;
        }
        //SLVI-1334-FIX-05-FIM

        const sessionToken = getCookie('sessionToken');

        if (!sessionToken) {
            const loginValido = localStorage.getItem('loginValido');
            console.log('[SESSION GUARD P7] Cookie sessionToken: NÃO ENCONTRADO');
            console.log('[SESSION GUARD P7] loginValido no storage:', loginValido);

            if (loginValido === null) {
                // Auth inicial ainda em andamento — aguarda sem redirecionar
                console.log('%c[SESSION GUARD P7] loginValido=null — auth inicial em andamento, aguardando', 'color: orange; font-weight: bold');
                return;
            }

            if (loginValido === 'true') {
                //SLVI-1334-FIX-05-INICIO
                // Sessão expirada: o cookie sumiu mas loginValido ainda diz "true"
                // Reseta o estado e redireciona para / para forçar re-autenticação
                // antes que qualquer chamada de API da página atual seja disparada
                console.log('%c[SESSION GUARD P7] Sessão EXPIRADA — resetando loginValido e redirecionando para re-autenticação', 'color: orange; font-weight: bold');
                console.log('%c[SESSION GUARD P7] TIMESTAMP redirect para /:', 'color: orange; font-weight: bold', new Date().toISOString());
                localStorage.removeItem('loginValido');
                localStorage.removeItem('colwsLoginValido');
                history.replace('/');
                console.log('%c[SESSION GUARD P7] history.replace("/") executado', 'color: orange; font-weight: bold');
                //SLVI-1334-FIX-05-FIM
                return;
            }

            const expires = localStorage.getItem('expires');
            const urlOrigem = localStorage.getItem('urlOrigem');
            if (loginValido === 'false' && !expires && urlOrigem) {
                console.log('%c[SESSION GUARD P7] loginValido=false mas sem expires e com urlOrigem — auth em andamento, aguardando', 'color: orange; font-weight: bold');
                return;
            }

            // loginValido === 'false' com expires ou sem urlOrigem: falha real de autenticação
            console.log('%c[SESSION GUARD P7] REDIRECIONANDO para /error — loginValido=false e sem cookie', 'color: red; font-weight: bold');
            localStorage.removeItem('colwsLoginValido');
            history.push('/error?erro=Sessão não encontrada. Acesse o portal do corretor novamente.');
            return;
        }

        console.log('[SESSION GUARD P7] Cookie sessionToken: ENCONTRADO ✅ — validando com /auth/colws/authz');

        axios.post('/auth/colws/authz', { sessionToken })
            .then(function(response) {
                var resultCode = response.data && response.data.resultCode;
                console.log('[SESSION GUARD P7] Resposta /auth/colws/authz — resultCode:', resultCode);
                if (resultCode !== 'AUTHORIZED') {
                    console.log('%c[SESSION GUARD P7] REDIRECIONANDO para /error — resultCode=' + resultCode, 'color: red; font-weight: bold');
                    //SLVI-1334-FIX-03-INICIO
                    // Limpa cookie e localStorage ao receber NOTAUTHORIZED, preservando urlOrigem
                    document.cookie = 'sessionToken=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Strict';
                    const savedUrlOrigem = localStorage.getItem('urlOrigem');
                    localStorage.clear();
                    if (savedUrlOrigem) localStorage.setItem('urlOrigem', savedUrlOrigem);
                    //SLVI-1334-FIX-03-FIM
                    history.push('/error?erro=Sessão inválida. Acesse o portal do corretor novamente.');
                } else {
                    console.log('%c[SESSION GUARD P7] Sessão AUTORIZADA ✅', 'color: green; font-weight: bold');
                }
            })
            .catch(function(error) {
                console.error('%c[SESSION GUARD P7] ERRO ao chamar /auth/colws/authz', 'color: red; font-weight: bold');
                console.error('[SESSION GUARD P7] HTTP status:', error?.response?.status);
                console.error('[SESSION GUARD P7] Resposta:', error?.response?.data);
                //SLVI-1334-FIX-03-INICIO
                // Limpa cookie e localStorage em caso de erro na validação, preservando urlOrigem
                document.cookie = 'sessionToken=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Strict';
                const savedUrlOrigem = localStorage.getItem('urlOrigem');
                localStorage.clear();
                if (savedUrlOrigem) localStorage.setItem('urlOrigem', savedUrlOrigem);
                //SLVI-1334-FIX-03-FIM
                history.push('/error?erro=Erro ao validar sessão. Acesse o portal do corretor novamente.');
            });

    }, [location.pathname]);
}
//SLVI-1334-FIM
